<span class="warning">
  <img src="../../../../assets/icons/warning.svg" alt="warning">
  <span [innerHTML]="text"></span>
</span>
